import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EPIC_FIELD_KEYS } from '../../79/_const';
import {
	addMessage,
	clearMessages,
} from '../../../../../../store/ancillary/actions';

/**
 * Wrapping component to manage state updates between Formik and Redux
 * @param {Object} props properties
 * @returns Container component
 */
const HybridContainer = ({
	formik,
	hasSubmissionBeenAttempted,
	fieldKeys = EPIC_FIELD_KEYS,
	...props
}) => {
	const dispatch = useDispatch();
	const globalLoading = useSelector(state => state.apps.loading);
	const globalSubmitting = useSelector(state => state.apps.submitting);
	const [submissionAttempted, setSubmissionAttempted] = useState(false);
	const [isSubmittable, setIsSubmittable] = useState(false);

	//when Redux state indicates this form has been touched, manually update for all fields
	useEffect(() => {
		// console.log('...touchedhandler 1,', props.validation.touched);
		// if (props?.validation?.touched) {
		// 	Object.values(EPIC_FIELD_KEYS).forEach(key => {
		// 		console.log('...touchedhandler,', key);
		// 		formik.setFieldTouched(key, true);
		// 	});
		// }
	}, [props.validation.touched]);

	useEffect(() => {
		if (hasSubmissionBeenAttempted) {
			Object.values(fieldKeys).forEach(key => {
				formik.setFieldTouched(key, true);
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasSubmissionBeenAttempted]);

	//when formik has no errors, we update the Redux state with our "value"
	useEffect(() => {
		let newValue = '';
		if (
			formik?.errors &&
			typeof formik.errors === 'object' &&
			Object.keys(formik.errors).length === 0
		) {
			newValue = JSON.stringify(formik.values);
			setIsSubmittable(true);
		} else {
			newValue = '';
			setIsSubmittable(false);
		}
		props.changeHandler({
			target: {
				id: props.name,
				name: props.name,
				value: newValue,
			},
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formik.errors, formik.values]);

	//monitor Redux state for loading + submitting combo (indicates user clicked Submit)
	useEffect(() => {
		if (globalLoading && globalSubmitting) {
			setSubmissionAttempted(true);
		}
	}, [globalLoading, globalSubmitting]);

	//dispatch a message when submission is attempted but not valid
	useEffect(() => {
		if (submissionAttempted) {
			if (props?.validation?.touched) {
				Object.values(fieldKeys).forEach(key => {
					formik.setFieldTouched(key, true);
				});
			}
		}

		if (submissionAttempted && !isSubmittable) {
			dispatch(
				addMessage({
					Key: 3,
					Value: 'Please complete all required fields for each application requested.',
				})
			);
		}
		if (submissionAttempted && isSubmittable) {
			dispatch(clearMessages());
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [submissionAttempted, isSubmittable]);

	return <>{props.children}</>;
};

export default HybridContainer;
